import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://onelightmanylamps.ai';
const SITE_NAME = 'One Light, Many Lamps';
const DEFAULT_IMAGE = `${SITE_URL}/book-cover.jpg`;

const PAGE_SEO = {
  '/': {
    title: 'One Light, Many Lamps — Where Ancient Wisdom Meets the Age of AI',
    description: 'Discover the seven universal patterns shared across all spiritual traditions. A modern guide to ancient wisdom, powered by AI. Free spiritual guidance and meditation tools.',
    keywords: 'spirituality, ancient wisdom, meditation, spiritual guidance, universal truth, wisdom traditions, mindfulness, spiritual book',
  },
  '/ask': {
    title: 'AI Spiritual Guide — Ask Questions About Life & Meaning | One Light, Many Lamps',
    description: 'Ask the AI Life Guide about life, meaning, suffering, love, or purpose. Get thoughtful answers grounded in the wisdom of many spiritual traditions. No judgment, no dogma.',
    keywords: 'spiritual guidance, AI spiritual advisor, life questions, meaning of life, spiritual counseling, ask spiritual question, wisdom AI',
  },
  '/patterns': {
    title: 'The Seven Universal Patterns of Spiritual Wisdom | One Light, Many Lamps',
    description: 'Explore the seven patterns that appear across every major spiritual tradition — from consciousness to ego dissolution, from presence to love. What if the mystics all saw the same thing?',
    keywords: 'spiritual patterns, universal wisdom, consciousness, ego, presence, mindfulness, spiritual traditions, mysticism, perennial philosophy',
  },
  '/practice': {
    title: 'Guided Meditation & Mindfulness Practice | One Light, Many Lamps',
    description: 'Practice meditation with our guided timer. Simple, focused mindfulness rooted in ancient contemplative traditions. Begin your journey inward.',
    keywords: 'guided meditation, meditation timer, mindfulness practice, contemplation, spiritual practice, meditation for beginners',
  },
  '/book': {
    title: 'One Light, Many Lamps — The Book | Spiritual Guide Across Traditions',
    description: 'Get the book that maps the seven universal patterns across all wisdom traditions. Download Chapter 1 free. A fresh look at spirituality for the modern seeker.',
    keywords: 'spiritual book, one light many lamps, wisdom traditions book, spirituality guide, ancient wisdom modern, buy spiritual book',
  },
  '/about': {
    title: 'About One Light, Many Lamps — Our Mission & Story',
    description: 'Learn about the One Light, Many Lamps project — a collaboration between human insight and AI to map the universal patterns of spiritual wisdom.',
    keywords: 'about one light many lamps, spiritual project, AI and spirituality, Sato, wisdom project',
  },
  '/pricing': {
    title: 'Pricing — AI Spiritual Guidance Plans | One Light, Many Lamps',
    description: 'Choose your plan for unlimited AI spiritual guidance. Free tier with 3 daily questions or premium unlimited access. Affordable wisdom for every seeker.',
    keywords: 'spiritual guidance pricing, AI advisor subscription, premium spiritual guidance, meditation subscription',
  },
  '/guidance': {
    title: "I'm Going Through Something — Find Your Pattern | One Light, Many Lamps",
    description: 'Struggling with grief, loneliness, anxiety, or loss of faith? Find the spiritual pattern that speaks to your pain, with practical exercises and AI-guided reflection.',
    keywords: 'spiritual help grief, loneliness spiritual guidance, anxiety meditation, loss of faith, existential crisis help, finding purpose, relationship pain spirituality',
  },
};

export default function SEO({ path }) {
  const seo = PAGE_SEO[path] || PAGE_SEO['/'];
  const canonicalUrl = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={path === '/book' ? 'book' : 'website'} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
}
